import { GotoReAuth } from './ReAuth';
import ErrorReason from '../ErrorReason';
import { LocalMessage } from 'hooks/business/conversation';
import { useTranslate } from '@tolgee/react';
import { useAnySuperUser } from 'hooks/useAnySuperUser';
import { useGetPermission } from 'hooks/business/useNewPermisson';

export const AuthFailMsg = ({ message }: { message: LocalMessage }) => {
  const { t } = useTranslate();
  const hasPermission = useGetPermission()('店铺管理');
  const name = useAnySuperUser(message.storeId);
  const msg = hasPermission
    ? t('scene.chatWorkspace.messageEditor.error.exceptionChatTip')
    : t('scene.chatWorkspace.messageEditor.error.exceptionNoPermissionChatTip', { name });

  return (
    <ErrorReason msg={msg} message={message} extra={<GotoReAuth storeId={message.storeId} />} />
  );
};
